import { render, staticRenderFns } from "./base_data.vue?vue&type=template&id=1ef7c1dc&scoped=true&"
import script from "./base_data.vue?vue&type=script&lang=js&"
export * from "./base_data.vue?vue&type=script&lang=js&"
import style0 from "./base_data.vue?vue&type=style&index=0&lang=less&"
import style1 from "./base_data.vue?vue&type=style&index=1&id=1ef7c1dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef7c1dc",
  null
  
)

export default component.exports